module.exports = __webpack_public_path__ + "img/支付宝.d7654ff8.svg";